import React, {useRef} from 'react';
import { connect } from 'react-redux';
import { snackActions } from '../../sc-utilities/SnackBar';
import { withStyles, Tooltip, IconButton, Typography } from '@material-ui/core';
import { hasPermission, formatDate } from '../../sc-utilities';
import ErrorLogList from './ErrorLogList';
import {download} from "../../sc-utilities/download.utils";
import { CloudDownload } from '@material-ui/icons';
import config from "../../../config/config";

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingTop: theme.spacing(),
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    progressBarr: {
        width: '100%',
        height: 5
    }
});


const ErrorLog = props => {
    const tableRef = useRef();
    const { classes, columns, translations, permissions, activeCustomer } = props;
    let visible = columns && columns['ErrorLog'];
    let tableColumns = [
        {
            title: translations["action"] || "Action", field: 'ErrorLogID',
            hidden: visible ? visible['ErrorLogID'] : false,
            cellStyle: { minWidth: 100, maxWidth: 100 },
            filtering: false,
            render: rowData => <>
                <Tooltip title={translations["download_log"] || "Download log"}>
                    <span>
                        <IconButton aria-label={translations["download_log"] || "Download log"} components={'div'} value={rowData.ErrorLogID} onClick={() => handleDownload(rowData.ErrorLogID)}>
                            <CloudDownload />
                        </IconButton>
                    </span>
                </Tooltip>
            </>
        },
        {
            title: translations["subject"] || 'Subject', field: 'Subject',
            hidden: visible ? visible['Subject'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Subject ? rowData.Subject : '-'}</Typography>;
            }
        },
        {
            title: translations["created_at"] || 'Created at', field: 'CreatedAt',
            hidden: visible ? visible['CreatedAt'] : false,
            filtering: false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.CreatedAt ? formatDate(rowData.CreatedAt) : '-'}</Typography>;
            }
        },
        {
            title: translations["reported_by"] || 'Reported by', field: 'Username',
            hidden: visible ? visible['Username'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData && rowData.User ? rowData.User.Username : ''}</Typography>;
            }
        }
    ];

    const handleDownload = async errorLogID => {
        const objectURL = `${config.backend_domain}:${config.backend_port}/error_logs/download?ErrorLogID=${errorLogID}&ActiveCustomerID=${activeCustomer}`;
        let exportDataSuccessful = await download(objectURL);
        tableRef.current && tableRef.current.onQueryChange();
        if (!exportDataSuccessful) {
            return snackActions.snackBarComponent(translations['download_error_msg'] || `Could not download file `, 'error');
        }
    }



    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'error_log_list') ?
                <ErrorLogList
                    tableColumns={tableColumns}
                    tableRef={tableRef}
                />
                :
                null}
        </div>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || []
    };
};

export default connect(
    mapStateToProps,
    null
)(withStyles(styles)(ErrorLog));
